import { useEffect, useCallback } from 'react'

import { useNavigate } from 'react-router-dom'

import { Header } from '@/components'
import { RoutesNames } from '@/routes/routes'
import { BridgeService } from '@/services'
import DynamicComponent from '@/components/DynamicComponent'
import type { ComponentType } from '@/components/DynamicComponent/interfaces'
import useGlobalState from '@/contexts/global-state'
import * as Actions from '@/contexts/global-state/reducer/actions'

import * as S from './styles'

export const HomeCredit = () => {
  const [{ homeCreditOnboarding }, dispatch] = useGlobalState()
  const navigate = useNavigate()
  const screen = homeCreditOnboarding?.screen
  const components = screen?.components ?? []
  const routeLeft = screen?.metadata?.header?.routeLeft

  const handleBackClick = useCallback(() => {
    if (routeLeft === 'superApp') {
      BridgeService.requestGoBack()
      return
    }

    if (routeLeft && routeLeft !== 'default') {
      dispatch(Actions.setApiRequest({ apiRequest: routeLeft }))
    }

    navigate({ pathname: RoutesNames.ROOT })
  }, [routeLeft, dispatch, navigate])

  useEffect(() => {
    BridgeService.requestAnalytics('CREDITO_ACESSO', {
      screen_name: 'HomeCredit: Emprestimo',
      component_name: 'HomeCredit',
      hierarchy: 'HomeCredit',
      label: 'HomeCredit',
    })
    if (homeCreditOnboarding === null || homeCreditOnboarding === undefined) {
      navigate({
        pathname: RoutesNames.ROOT,
      })
    }
  }, [navigate, homeCreditOnboarding])

  return (
    <S.Container>
      <Header
        title={screen?.metadata?.header?.title ?? 'Empréstimos'}
        onBackClick={handleBackClick}
      />
      {components.map((component) => (
        <DynamicComponent
          key={component.id}
          type={component.type as ComponentType}
          sduiComponent={{
            id: component.id,
            type: component.type,
            style: component.style,
            props: component.props,
            path: component.path,
            analytics: component.analytics,
          }}
        />
      ))}
    </S.Container>
  )
}
